import { computed } from 'vue'
import { useHashToToggle } from '../../composables/useHashToToggle'
import Modal from '../Modal/Modal.vue'

export default {
    name: 'LegalText',
    components: {
        Modal,
    },
    props: {
        juraModal: {
            type: Object,
            required: true,
        },
    },
    setup(props) {
        const { activeData, clearHash } = useHashToToggle([props.juraModal])

        const isOpen = computed(() => activeData.value !== null)
        const title = computed(() => activeData.value?.title || '')
        const body = computed(() => activeData.value?.description || '')

        return {
            isOpen,
            title,
            body,
            close: clearHash,
        }
    },
}
